/* unplugin-vue-components disabled */import { render } from "./404.vue?vue&type=template&id=1f752130"
const script = {}

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__